export const types = {
  'SET_REFRESH_PAYMENT_TERMS_STATUS': 'SET_REFRESH_PAYMENT_TERMS_STATUS',
  'SET_PAYMENT_TERMS': 'SET_PAYMENT_TERMS',
  'SET_PAYMENT_TERMS_LOADING': 'SET_PAYMENT_TERMS_LOADING',
  'UPDATING_PAYMENT_TERM': 'UPDATING_PAYMENT_TERM',
  'UPDATE_PAYMENT_TERMS': 'UPDATE_PAYMENT_TERMS',
  'UPDATE_PAYMENT_TERMS_FAILED': 'UPDATE_PAYMENT_TERMS_FAILED'
};
